import * as studyPlanTasksApi from "api/study_plan_tasks";

import { useQuery } from "react-query";

export function useStudyPlanTasks(): {
  tasks: any[];
  currentStepNumber: number;
  stepsCount: number;
  completedRate: number;
  isLoading: boolean;
  isFetching: boolean;
} {
  const {
    data: response,
    isLoading,
    isFetching
  } = useQuery("study_plan_tasks", studyPlanTasksApi.index);
  const data = response?.body?.data || {};
  const tasks = data.tasks || [];

  return { ...data, tasks: tasks, isLoading, isFetching };
}
